module.exports = __webpack_public_path__ + "img/AAK_mønt_RGB_hvid.de295c9c.svg";